import { Breadcrumbs, withStyles } from '@material-ui/core';

import { colors, fonts } from '../styles';

export const StyledBreadcrumbs = withStyles({
  li: {
    '& a': {
      color: colors.gray.default,
      fontSize: fonts.size.small,
      cursor: 'pointer',

      '&.selected': {
        color: colors.gray.dark,
        fontWeight: fonts.weight.medium,
        cursor: 'default',
      },

      '&:hover': {
        color: colors.gray.dark,
      },

      '&.disabled': {
        color: colors.gray.default,
        fontSize: fonts.size.small,
        cursor: 'default',

        '&:hover': {
          color: colors.gray.default,
        },
      },
    },
  },
  separator: {
    margin: '0 10px',
    color: colors.gray.default,
    display: 'flex',
    alignItems: 'center',
  },
})(Breadcrumbs);
